import { useSelector } from 'react-redux';

import { DefaultPaymentMethod } from 'organisms/DefaultPaymentMethod';

export default function DefaultPayment() {
  const { appointment } = useSelector((state) => state.checkout);
  return (
    <div className="mb-12 p-24 border-light-purple radius-24">
      <h4 className="mb-8">Payment</h4>
      <DefaultPaymentMethod
        cards={appointment.user.payment.methods.cards}
        savedCardLabel
      />
    </div>
  );
}
